import { useEffect, useState } from 'react';
import { getPrescriptionsByTextVisit } from 'api/textVisit';
import { TPrescriptionListItem } from 'types/textVisit';

export default function useGetPrescriptionByTextVisit(): [TPrescriptionListItem[], boolean, (textVisitId: number) => void] {
    const [loading, setLoading] = useState(false);
    const [caseList, setCaseList] = useState<TPrescriptionListItem[]>([]);

    const fetchData = async (textVisitId: number) => {
        try {
            setLoading(true);
            const result = await getPrescriptionsByTextVisit(textVisitId);
            if (!result.error) {
                const data: TPrescriptionListItem[] = result?.data?.data?.list || [];
                setCaseList(data);
            }
            setLoading(false);
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    return [caseList, loading, fetchData];
}
